export const HUMAN_LEGIBLE_DEFAULT_HELP_HOTLINE = '(833) 609-1160';
export const DEFAULT_HELP_HOTLINE = '8336091160';

export const MAIN_CONTENT_ID = 'main-content-id';

export const BLEND_URL_INDICATORS = {
    BLEND_SSO: '/mortgage/sso/saml/login',
    SAML_AUTHN: 'saml-authn',
    BLEND_ACTIVATE: 'activate',
    BLEND_DIRECT: 'blendlabs',
};

export const Z_LAYERS = {
    ALWAYS_ON_TOP: 100,
    MODAL: 10000000,
};

export const ROUTES = {
    DASHBOARD: '/dashboard',
    DASHBOARD_BOUNCE: '/dashboard/login',
    GOLDENEYE_REDIRECT_DESTINATION: '/homeloans/',
    COMBINED_ZHL_FUNNEL_ENTRY: '/get-started',
    PURCHASE_FUNNEL_ENTRY: '/pre-qualify',
    ACTIVATE: '/dashboard/activate',
    ACTIVATE_FAILURE_PAGE: '/dashboard/activation-failure',
    BASE: '/mortgage',
    ROOT: '/',
};
export const ZILLOW_DOMAINS = {
    NON_PROD: 'https://www.qa.zillow.net',
    PROD: 'https://www.zillow.com',
};
export const ZHL_DOMAINS = {
    DEVELOPMENT: 'https://www.dev.zillowhomeloans.net',
    STAGING: 'https://www.staging.zillowhomeloans.net',
    PROD: 'https://www.zillowhomeloans.com',
};

export const STORYBOOK_CONSTELLATION_VIEWPORTS = {
    XS: 'constellationXs',
    SM: 'constellationSmMax',
    MD: 'constellationMdMax',
    LG: 'constellationLgMax',
    XL: 'constellationXlMax',
};

export const CYPRESS_INTEGRATION_TEST_IDS = {
    DEVELOPMENT_TOOLS: {
        GO_TO_MORTGAGE_DASHBOARD: 'go-to-mortgage-dashboard',
        GO_TO_APPLICATION_DASHBOARD: 'go-to-application-dashboard',
        CREATE_LOAN_APPLICATION_FOR_ACCOUNT: 'create-loan-application-for-account',
    },
    ABAD: {
        modal: 'abad-modal',
        header: 'abad-conversational-heading',
        centeredHeading: 'abad-title-heading',
        abadContent: 'abad-content',
        closeButton: 'abad-dismiss-button',
    },
    MOLECULAR: {
        CONFIRMATION_DIALOG: {
            MODAL: 'molecular-confirmation-dialog-modal',
            HEADER: 'molecular-confirmation-dialog-header',
            BODY: 'molecular-confirmation-dialog-body',
            CONFIRM_BUTTON: 'molecular-confirmation-dialog-confirm',
            CANCEL_BUTTON: 'molecular-confirmation-dialog-cancel',
        },
    },
    MORTGAGE_DASHBOARD: {
        HERO_IMAGE: 'mortgage-dashboard-hero-image',
        PAGE: 'mortgage-dashboard',
        EXPERIENCES: {
            NEW_APPLICATION: {
                RESOURCE_CARD: {
                    TITLE: 'landing-experience-info-heading',
                    CTA: 'landing-experience-info-cta',
                    MODAL: 'landing-modal-heading',
                    MODAL_CTA: 'landing-modal-cta',
                },
                UPSELL: {
                    TEXT: 'landing-experience-header',
                    CTA: 'landing-experience-hero-cta',
                    PHONE_CALL_LINK: 'landing-experience-phone',
                },
            },
            OUTSTANDING_TASKS: {
                RESOURCE_CARD: {
                    TITLE: 'offer-accepted-info-heading',
                    CTA: 'offer-accepted-info-cta',
                    MODAL: 'offer-accepted-modal-heading',
                },
                UPSELL: {
                    TITLE: 'offer-accepted-experience-header',
                    TEXT: 'offer-accepted-experience-text',
                    CTA: 'offer-accepted-experience-cta',
                },
            },
            VERIFIED_PRE_APPROVAL: {
                RESOURCE_CARD: {
                    TITLE: 'pre-approval-info-heading',
                    CTA: 'pre-approval-info-cta',
                    MODAL: 'pre-approval-modal-heading',
                    MODAL_CTA: 'pre-approval-modal-cta',
                },
                UPSELL: {
                    TEXT: 'pre-approval-experience-heading',
                    CTA: 'pre-approval-experience-cta',
                    MODAL: 'pre-approval-experience-modal-heading',
                },
            },
            DIGITAL_PREAPPROVAL_VERIFIED_PRE_APPROVAL: {
                UPSELL: {
                    TEXT: 'digital-pre-approval-verified-pre-approval-experience-heading',
                    CTA: 'digital-pre-approval-verified-pre-approval-experience-cta',
                    MODAL: 'digital-pre-approval-verified-pre-approval-experience-modal-heading',
                },
            },
            DIGITAL_PREAPPROVAL_VERIFIED_OUTSTANDING_TASKS: {
                UPSELL: {
                    TEXT: 'digital-pre-approval-verified-pre-approval-with-tasks-experience-heading',
                    CTA: 'digital-pre-approval-verified-pre-approval-with-tasks-experience-cta',
                    SECONDARY_CTA: 'digital-pre-approval-verified-pre-approval-with-tasks-experience-secondary-cta',
                    MODAL: 'digital-pre-approval-verified-pre-approval-with-tasks-experience-modal-heading',
                },
            },
            WAITING_TO_CLOSE: {
                UPSELL: {
                    TEXT: 'waiting-experience-heading',
                },
                RESOURCE_CARD: {
                    TITLE: 'waiting-info-heading',
                    CTA: 'waiting-info-cta',
                    MODAL: 'waiting-modal-heading',
                },
            },
        },
        VIEW_SAVED_INFORMATION: {
            CTA: 'access-your-info-cta',
        },
        RESOURCE_CARD_MODAL: 'resource-card-modal',
        ZDOCS_DOCUMENT_VIEWER: {
            MODAL: 'zdocs-document-viewer-modal',
            MODAL_FRAME: 'zdocs-document-view-modal-frame',
            MODAL_BANNER: 'zdocs-document-viewer-modal-banner',
            DOWNLOAD_BUTTON: 'zdocs-document-viewer-download-button',
            MOBILE_DOWNLOAD_BUTTON: 'zdocs-document-viewer-download-button-mobile',
            PRINT_BUTTON: 'zdocs-document-viewer-print-button',
            SHARE_BUTTON: 'zdocs-document-viewer-share-button',
        },
        WELCOME_BANNER: {
            BANNER: 'welcome-banner',
        },
        YOUR_TEAM_CARD: {
            GENERIC_HOTLINE: 'generic-hotline',
            FULL_NAME: 'assigned-team-member-full-name',
            TITLE: 'assigned-team-member-title',
            PHONE: 'assigned-team-member-phone',
            EMAIL: 'assigned-team-member-email',
        },
        ERROR_PAGE: {
            ACTIVATION_FAILURE_HEADER: 'activation-failure-header',
            ACTIVATION_FAILURE_MESSAGE: 'activation-error-message',
        },
    },
    DASHBOARD_LINK: 'navbar-dashboard',
} as const;
export const ERROR_PREFIXES = {
    APOLLO: '[APOLLO]',
    ANALYTICS: '[ANALYTICS]',
    DASHBOARD: '[DASHBOARD]',
    APPLICATION_SESSION: '[APPLICATION SESSION]',
    OAUTH: '[OAUTH]',
    PUBLIC_SETTINGS_API: '[Public Settings API]',
    MAX_API: '[MAX API]',
};
export const CYPRESS_ID_ATTRIBUTE = 'data-testid';
